export const OrderStatusEnum = {
  ORDER_PENDING_APPROVAL: 1, // Pedido em aprovação
  ORDER_NOT_APPROVED: 2, // Cancelado
  BILLING_ORDER: 3, // Pedido em faturamento
  PREPARING_ORDER: 4, // Pedido em preparação
  ORDER_SENT_TO_TRANSPORT: 5, // Pedido enviado para transporte
  SCHEDULING_ORDER: 6, // Pedido em agendamento
  TRY_SCHEDULLING_ORDER: 7, // Tentativa de agendamento
  ORDER_NOT_SCHEDULED: 8, // Pedido não agendado
  ORDER_IN_TRANSPORT: 9, // Pedido em transporte
  DELIVERY_ATTEMPT: 10, // Tentativa de entrega
  ORDER_DELIVERED: 11, // Pedido entregue
  ORDER_NOT_DELIVERED: 12, // Pedido não entregue
  ORDER_CANCELED: 13, // Pedido cancelado
  ORDER_REFUSED: 14, // Pedido recusado
  ORDER_STATUS_APROVED: 15, // Pedido aprovado
  ORDER_STATUS_ERP_EXPORT: 16, // Exportar ERP
  BILLED_ORDER: 17, // Pedido faturado
  PREPARED_ORDER: 18, // Pedido preparado
};

export const OrderStatusText = {
  [OrderStatusEnum.ORDER_PENDING_APPROVAL]: 'Em aprovação',
  [OrderStatusEnum.ORDER_STATUS_APROVED]: 'Aprovado',
  [OrderStatusEnum.ORDER_NOT_APPROVED]: 'Cancelado',
  [OrderStatusEnum.BILLING_ORDER]: 'Faturamento',
  [OrderStatusEnum.BILLED_ORDER]: 'Faturado',
  [OrderStatusEnum.ORDER_STATUS_ERP_EXPORT]: 'Exportar ERP',
  // [OrderStatusEnum.ORDER_STATUS_ERP_ERROR]: 'Erro na exportação ERP',
  [OrderStatusEnum.PREPARING_ORDER]: 'Em preparação',
  [OrderStatusEnum.PREPARED_ORDER]: 'Preparado',
  [OrderStatusEnum.ORDER_SENT_TO_TRANSPORT]: 'Enviado para transporte',
  [OrderStatusEnum.SCHEDULING_ORDER]: 'Pedido em agendamento',
  [OrderStatusEnum.TRY_SCHEDULLING_ORDER]: 'Tentativa de agendamento',
  [OrderStatusEnum.ORDER_NOT_SCHEDULED]: 'Pedido não agendado',
  [OrderStatusEnum.ORDER_IN_TRANSPORT]: 'Em transporte',
  [OrderStatusEnum.DELIVERY_ATTEMPT]: 'Tentativa de entrega',
  [OrderStatusEnum.ORDER_DELIVERED]: 'Entregue',
  [OrderStatusEnum.ORDER_NOT_DELIVERED]: 'Entregue pendente',
  [OrderStatusEnum.ORDER_CANCELED]: 'Cancelado',
  [OrderStatusEnum.ORDER_REFUSED]: 'Recusado',
};
